import { isActiveStarsFilter } from "@modules/azm/filter"

const topStarsStripeContainer = () => document.querySelector("#azm-stars-promotional-content")

export function topStarsStripeChangeVisibility(visible: boolean) {
    const domContainer = topStarsStripeContainer()

    if (!domContainer) {
        console.warn(
            "no top stars strip container found to show or hide using query selector: #azm-stars-promotional-content",
        )
        return
    }

    if (visible) {
        domContainer.removeAttribute("hidden")
    } else {
        domContainer.setAttribute("hidden", "")
    }
}

topStarsStripeChangeVisibility(!isActiveStarsFilter())
